var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useContext } from 'react';
import moment from 'moment/moment';
import { v4 as uuid } from 'uuid';
import { MessageReplyQueueContext } from '../../contexts/messageReplyQueueContext';
var generatePendingMessage = function (conversationSlug, body) { return ({
    body: body,
    conversationSlug: conversationSlug,
    isPending: true,
    // This id is only used locally to remove pending messages
    // when the real message has been created.
    id: uuid(),
    createdOn: moment().toISOString(),
}); };
/**
 * Provides access to the messageReplyQueue, that is used as temporary storage
 * for pending- or failing messages.
 * */
var useMessageReplyQueue = function () {
    var _a = useContext(MessageReplyQueueContext), state = _a.state, dispatch = _a.dispatch;
    var insertPendingMessage = function (conversationSlug, message) {
        var pendingMessage = generatePendingMessage(conversationSlug, message);
        dispatch({
            type: 'INSERT_PENDING_MESSAGE',
            message: pendingMessage,
        });
        return pendingMessage;
    };
    var updatePendingMessage = function (pendingMessage) {
        dispatch({
            type: 'INSERT_PENDING_MESSAGE',
            message: pendingMessage,
        });
    };
    var removePendingMessage = function (pendingMessage) {
        dispatch({
            type: 'REMOVE_PENDING_MESSAGE',
            message: pendingMessage,
        });
    };
    var markPendingMessageAsFailed = function (pendingMessage, error) {
        var failingMessage = __assign(__assign({}, pendingMessage), { error: error });
        dispatch({
            type: 'INSERT_FAILING_PENDING_MESSAGE',
            message: failingMessage,
        });
        return failingMessage;
    };
    return {
        messageReplyQueue: state.messageReplyQueue,
        insertPendingMessage: insertPendingMessage,
        updatePendingMessage: updatePendingMessage,
        removePendingMessage: removePendingMessage,
        markPendingMessageAsFailed: markPendingMessageAsFailed,
    };
};
export default useMessageReplyQueue;
